import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Box,
  Button,
  Input,
  FormControl,
  FormLabel,
  Heading,
  Text,
  VStack,
  Image,
  Center,
  Alert,
  AlertIcon,
  Flex,
  useColorModeValue,
} from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { api } from '../../utils/api';
import logo from '../../Images/logo_tovi.png';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  // Dynamic colors
  const bgMain = useColorModeValue('white', 'gray.800');
  const shadow = useColorModeValue('lg', 'dark-lg');
  const inputBg = useColorModeValue('white', 'gray.700');
  const labelColor = useColorModeValue('gray.700', 'gray.300');
  const headingColor = useColorModeValue('gray.700', 'gray.100');
  const footerColor = useColorModeValue('gray.500', 'gray.400');

  const submitHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await api.post('api/webuser/forgot-password', { email });
      
      if (!response) {
        setIsLoading(false);
        return;
      }

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
      } else {
        setError(data.message || 'Erro ao enviar email de recuperação.');
      }
    } catch (error) {
      setError('Erro de conexão. Por favor, verifique sua conexão com a internet.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Flex minH="100vh" align="center" justify="center" bg="gray.50">
      <Box bg={bgMain} rounded="xl" boxShadow={shadow} p={8} w="100%" maxW="400px" textAlign="center">
        <Center mb={6}>
          <Image src={logo} alt="Handyman Logo" maxH="120px" objectFit="contain" />
        </Center>

        <Text fontSize="xl" fontWeight="bold" color="teal.600" mb={2}>
          TOVI App Administração
        </Text>

        <Heading as="h1" size="lg" mb={8} color={headingColor}>
          Recuperar Senha
        </Heading>

        {error && (
          <Alert status="error" mb={6} borderRadius="md">
            <AlertIcon />
            {error}
          </Alert>
        )}

        {success ? (
          <VStack spacing={4}>
            <Alert status="success" borderRadius="md">
              <AlertIcon />
              <Box>
                <Text fontWeight="bold">Email enviado com sucesso!</Text>
                <Text fontSize="sm" mt={2}>
                  Verifique sua caixa de entrada para instruções de recuperação de senha.
                </Text>
              </Box>
            </Alert>
            <Button
              leftIcon={<ArrowBackIcon />}
              colorScheme="teal"
              variant="outline"
              onClick={() => navigate('/login')}
              width="full"
            >
              Voltar ao Login
            </Button>
          </VStack>
        ) : (
          <>
            <Text fontSize="sm" color={labelColor} mb={6}>
              Digite seu email e enviaremos instruções para redefinir sua senha.
            </Text>

            <form onSubmit={submitHandler}>
              <VStack spacing={5}>
                <FormControl id="email" isRequired>
                  <FormLabel color={labelColor}>Email</FormLabel>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="seu-email@exemplo.com"
                    size="md"
                    focusBorderColor="teal.500"
                    bg={inputBg}
                  />
                </FormControl>

                <Button
                  colorScheme="teal"
                  type="submit"
                  width="full"
                  size="lg"
                  mt={4}
                  isLoading={isLoading}
                  loadingText="Enviando..."
                >
                  Enviar Email de Recuperação
                </Button>

                <Link to="/login" style={{ width: '100%' }}>
                  <Button
                    leftIcon={<ArrowBackIcon />}
                    variant="outline"
                    width="full"
                    size="md"
                  >
                    Voltar ao Login
                  </Button>
                </Link>
              </VStack>
            </form>
          </>
        )}

        <Text mt={8} fontSize="sm" color={footerColor}>
          © {new Date().getFullYear()} TOVI App. Todos os direitos reservados.
        </Text>
      </Box>
    </Flex>
  );
};

export default ForgotPassword;
